import React, { Fragment } from "react";
import { StepRenderProps } from "../../../interfaces/FlowInterfaces";
import { observer } from "mobx-react";
import { ExistingAccountConfirmationStepValues } from "../../_interfaces/IOrganizationSignUpStepTypeValues";
import { IOrganizationSignUpFlowValues } from "../../_interfaces/IOrganizationSignUpFlowValues";
import { useExistingAccountConfirmationController } from "../../hooks/useExistingAccountConfirmationController";
import { VerifyCorrectAccountForm } from "../../../../authentication/components/VerifyCorrectAccountForm";
import { OrganizationSignUpHeader } from "../OrganizationSignUpHeader";
import { BackButton } from "./BackButton";

export const VerifyCorrectAccountStep: React.FC<
    StepRenderProps<ExistingAccountConfirmationStepValues, IOrganizationSignUpFlowValues>
> = observer(({
    values,
    update,
    submit,
    canSubmit,
    validation,
    allValues
}) => {

    /********* React hooks *********/

    const controller = useExistingAccountConfirmationController(values, allValues, update, submit);

    /********* Render *********/

    return (
        <Fragment>
            <OrganizationSignUpHeader />
            <VerifyCorrectAccountForm
                values={controller.values}
                onChange={(patch) => {
                    controller.onChange(patch);
                    update(patch); // sync with Flow
                }}
                onSubmit={controller.onSubmit}
                isSubmitting={controller.isSubmitting}
                error={controller.error}
                fieldErrors={controller.fieldErrors}
            />
            <BackButton
                onClicked={() => controller.onSubmit({ backClicked: true })}
                isSubmitting={controller.isSubmitting}
            />
        </Fragment>
    );
});